<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav :selectedLanguage="selectedLanguage" page="blog" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="blog-article">
            <Breadcrumb />
            <header class="blog-header">
              <h1>Setting Up GBWhatsApp for Maximum Efficiency</h1>
            </header>

            <div class="blog-content">
              <div class="blog-intro">
                <img src="@/assets/blog-1-1.webp" alt="Set Up GB for Efficiency cover" class="blog-featured-image">
                <p>Most people <a href="https://gbwhataps.com/download/" class="jump-url">install <strong>GBWhatsApp </strong></a> just to try its extra themes or dual accounts, but with the right setup, it can do much more. This short guide walks you through how to make your GBWhatsApp faster, smarter, and truly your own.</p>
              </div>

              <div class="content-section">
                <h2>Get the Latest GBWhatsApp APK</h2>
                <p>Always download the newest <strong>GBWhatsApp</strong> version from a trusted source. It gives you bug fixes, new privacy tools, and a smoother chat experience.</p>
              </div>

              <div class="content-section">
                <h2>Enable "Unknown Sources"</h2>
                <p>Go to <strong>Settings</strong> �?<strong>Security</strong> �?<strong>Unknown Sources</strong> and turn it on. This allows your phone to install the GBWhatsApp APK safely.</p>
              </div>

              <div class="content-section">
                <h2>Install and Verify</h2>
                <p>Locate the APK in your file manager, tap <strong>Install</strong>, and open the app. Enter your number, verify via OTP, and restore your chat backup if needed.</p>
              </div>

              <div class="content-section">
                <h2>Customize Everything</h2>
                <p>Change fonts, colors, and chat backgrounds inside <strong>GB Settings</strong>. With GBWhatsApp, even your chat bubbles and icons can match your mood.</p>
              </div>

              <div class="content-section">
                <h2>Control Your Privacy</h2>
                <p>Hide your online status, freeze your last seen, or disable blue ticks �?<strong>GBWhatsApp</strong> lets you decide how visible you are.</p>
              </div>

              <div class="content-section">
                <h2>Automate Messages</h2>
                <p>Use <strong>Auto-Reply</strong> or <strong>Message Scheduler</strong> to send texts automatically �?perfect for business users, reminders, or just staying organized.</p>
              </div>

              <div class="content-section">
                <img src="@/assets/blog-1-2.webp" alt="Auto-reply supp" class="blog-content-image">
                <h2>Run Two Accounts at Once</h2>
                <p>Keep personal and work life separate with <strong>dual WhatsApp accounts</strong> on the same device. Each can have its own settings, themes, and tone.</p>
              </div>

              <div class="content-section">
                <h2>Keep It Updated</h2>
                <p>Since GBWhatsApp doesn't update automatically, check trusted sources regularly for new versions. Updates help maintain performance and anti-ban protection.</p>
              </div>

              <div class="content-section">
                <p>When set up with care, <strong>GBWhatsApp</strong> turns from a simple mod into a flexible space where your messages feel more private, more organized, and more you.</p>
              </div>
            </div>

          </article>
        </main>
      </div>
    </div>
  </div>

  <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    Download GBWhatsapp APK
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
  name: 'Blog1',
  components: {
    HeadNav,
    Breadcrumb,
  },
  data() {
    return {
      pageName: 'blog-1',
      selectedLanguage: 'en',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    goto(name) {
      this.$router.push({
        name: `${name}`
      });
    },
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhataps.com',
          appName: appname || 'GB_gbwhataps.com',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    gotoHome(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style scoped>
.blog-article {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.blog-header {
  text-align: center;
  margin-bottom: 40px;
}

.blog-header h1 {
  font-size: 2.5em;
  color: #25D366;
  margin-bottom: 20px;
  line-height: 1.2;
}

.blog-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  color: #666;
  font-size: 0.9em;
}

.blog-meta span {
  padding: 5px 15px;
  background: #f5f5f5;
  border-radius: 20px;
}

.blog-content {
  line-height: 1.8;
  font-size: 1.1em;
}

.blog-intro {
  margin-bottom: 40px;
}

.blog-featured-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 10px;
  margin: 0 auto 30px;
  display: block;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.blog-content-image {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 10px;
  margin: 20px auto;
  display: block;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.content-section {
  margin-bottom: 35px;
}

.content-section h2 {
  color: #25D366;
  font-size: 1.8em;
  margin-bottom: 15px;
  border-left: 4px solid #25D366;
  padding-left: 15px;
}

.content-section p {
  margin-bottom: 15px;
  color: #333;
}

.content-section.conclusion {
  padding: 25px;
  border-radius: 10px;
  font-style: italic;
  font-size: 1.1em;
}

.blog-navigation {
  margin-top: 50px;
  text-align: center;
}

.back-to-blog {
  display: inline-block;
  padding: 12px 25px;
  background: #25D366;
  color: white;
  text-decoration: none;
  border-radius: 25px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.back-to-blog:hover {
  background: #1ea952;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
}

.jump-url {
  color: #25D366;
  text-decoration: none;
  font-weight: 500;
}

.jump-url:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .blog-article {
    padding: 15px;
  }
  
  .blog-header h1 {
    font-size: 2em;
  }
  
  .blog-meta {
    flex-direction: column;
    gap: 10px;
  }
  
  .content-section h2 {
    font-size: 1.5em;
  }
}
</style>
